<template>
  <div class="page">
    <div class="leftContent">
      <div class="boxItem">
        <div class="itemTitle">门店</div>
        <div>
          <el-select
          :disabled="!$buttonAuthority('huoti-pethouse-shop')"
            style="width: 110px; margin: 10px 10px 0 0"
            class="select"
            v-model="shopId"
            @change="changeCurShopId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in shops"
              :key="item.shop_id"
              :label="item.shop_name"
              :value="item.shop_id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="boxItem">
        <el-tree
          default-expand-all
          :data="cageData"
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
    </div>
    <div class="rightContent">
      <div class="right_top_content">
        <div class="firstContent">
          <div class="conItem" @click="changeStatus('')">
            <span class="colorView color_5"></span>
            <span>全部({{ allCageCount }})</span>
          </div>
          <div class="conItem" @click="changeStatus('0')">
            <span class="colorView color_1"></span>
            <span>未入住({{ statusStatistics.null }})</span>
          </div>
          <div class="conItem" @click="changeStatus('9')">
            <span class="colorView color_2"></span>
            <span>已入住({{ statusStatistics.full }})</span>
          </div>
          <div class="conItem" @click="changeStatus('2')">
            <span class="colorView color_3"></span>
            <span>锁定({{ statusStatistics.lock }})</span>
          </div>
          <div class="conItem" @click="changeStatus('1')">
            <span class="colorView color_4"></span>
            <span>维修({{ statusStatistics.repair }})</span>
          </div>
        </div>
        <div class="firstContent" style="justify-content: space-between">
          <div style="display: flex">
            <el-input
              v-model="keyword"
              placeholder="芯片 | 脖圈 | 笼子号"
              prefix-icon="el-icon-search"
              @keyup.enter.native="getCageList"
            ></el-input>
            <el-button type="warning" @click="getCageList">搜索</el-button>
          </div>
          <div>
            <span>状态：</span>
            <el-select
              v-model="status"
              placeholder="请选择"
              @change="getCageList"
            >
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button type="warning" @click="reset">重置</el-button>
            <el-button
              type="warning"
              @click="addCage"
              v-show="$buttonAuthority('huoti-pethouse-addcage')"
              >创建房间
            </el-button>
          </div>
        </div>
        <!-- <hr /> -->
      </div>

      <div class="cageView">
        <div
          class="rightContent"
          v-show="!cageList.length"
          style="
            text-align: center;
            margin: 80px auto;
            font-size: 30px;
            font-weight: 700;
            height: 100vh;
          "
        >
          暂无房间信息
        </div>
        <div v-for="(itemb, index) in cageListArr" :key="itemb.id">
          <div class="cageName" v-show="itemb.length">
            {{ cagePositionNameList[index] }}
          </div>
          <div class="cageBox">
            <div
              class="cageItem"
              v-for="item in itemb"
              :key="item.id"
              @click="cageDetail(item)"
              :class="getClass(item.status.value)"
            >
              <div style="display: flex; justify-content: space-between;margin-bottom: 10px;">
                <div style="font-weight: 600; margin-bottom: 5px;color: white;">
                  {{ item.cageName }}
                </div>
                <div
                  class="cage_state"
                  :class="getTextClass(item.status.value)"
                >
                  {{ item.status.title }}
                </div>
              </div>
              <div
                style="text-align: center; margin-bottom: 5px;color: white;font-size: 12px;"
                v-for="itemA in item.pets.slice(0, 2)"
                :key="itemA.id"
              >
                {{ itemA.insideName }}
                <img
                v-if="itemA.saleStatus"
                  src="../../../assets/img/yishou.png"
                  v-show="itemA.saleStatus.value == '9'"
                  style="width: 15px; height: 15px; margin-top: 0px"
                  alt=""
                />
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: center;
                  margin-top: 2px;
                  color: white;
                  cursor: pointer;
                "
                v-show="item.pets.length > 2"
                @click="cageDetail(item)"
              >
                更多...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新建房间 -->
    <el-dialog
      title="新建房间"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialogItem">
        <div>区域</div>
        <div>
          <el-select v-model="areaId" placeholder="请选择" @change="changeArea">
            <el-option
              v-for="item in areaList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="dialogItem">
        <div>位置</div>
        <div>
          <el-select v-model="positionId" placeholder="请选择">
            <el-option
              v-for="item in positionList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="dialogItem">
        <div>名称</div>
        <div>
          <el-input placeholder="请输入内容" v-model="name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" plain @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="warning" @click="addShopCage">确认</el-button>
      </span>
    </el-dialog>
    <!-- 房间详情 -->
    <div v-if="cageDetailState">
      <dialogCageDetail
        :cageInfo="cageInfo"
        :cageId="cageId"
        @submit="submit_drawerStatus"
      ></dialogCageDetail>
    </div>
  </div>
</template>

<script>
import dialogCageDetail from "./dialog/dialog_cageDetail.vue";
import shopList from "../../../util/shopList";
export default {
  components: {
    dialogCageDetail,
  },
  data() {
    return {
      cageInfo: null,
      cageId:'',
      keyword: "",
      cageDetailState: false,
      status: "",
      statusList: [],
      name: "",
      areaList: [],
      positionId: "",
      positionList: [],
      areaId: "",
      // 展示区
      showList: [],
      cageData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 笼子位置
      tableData: [],
      // 新建房间
      dialogVisible: false,
      search: "",
      value: "001",
      shopId: this.$store.state.shopId,
      cageList: [],
      cageListArr: [],
      // 位置列表
      cagePositionList: [],
      cagePositionNameList: [],
      shops: shopList,
      statusStatistics: {
        full: "",
        lock: "",
        repair: "",
        null: "",
      },
    };
  },

  mounted() {
   
    this.getCageArea();
    this.getCageTree();
    this.getStatusList();
    this.getCageList();
    this.getStatistics();
  },
  computed: {
    allCageCount() {
      return (
        this.statusStatistics.null +
        this.statusStatistics.full +
        this.statusStatistics.lock +
        this.statusStatistics.repair
      );
    },
  },
  methods: {
    changeStatus(str) {
      this.status = str;
      this.getCageList();
    },
    // 获取笼子列表
    getCageList() {
      let params = {
        keyword: this.keyword,
        shopId: this.shopId,
        cageAreaId: this.cageAreaId,
        positionId: this.positionId,
        status: this.status,
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/shop/cage/current/status/list",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.cageList = res.data;
            let allArr = [];
            this.cagePositionList.forEach((itemA) => {
              let arr = this.cageList.filter(
                (itemB) => itemA == itemB.positionId
              );
              allArr.push(arr);
            });
            this.cageListArr = allArr;
          }
        });
    },

    // 获取笼子统计数据
    getStatistics() {
      let loading = this.$loading();
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/statistics", {
          shopId: this.shopId,
        })
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.statusStatistics = res.data.statusStatistics;
          }
        });
    },
    getTextClass(num) {
      if (num == "0") {
        return "textClass_1";
      } else if (num == "9") {
        return "textClass_2";
      } else if (num == "2") {
        return "textClass_3";
      } else if (num == "1") {
        return "textClass_4";
      }
    },
    getClass(num) {
      if (num == "0") {
        return "color_1";
      } else if (num == "9") {
        return "color_2";
      } else if (num == "2") {
        return "color_3";
      } else if (num == "1") {
        return "color_4";
      }
    },
    //重置
    reset() {
      this.keyword = "";
      this.cageAreaId = "";
      this.positionId = "";
      this.status = "";
      this.getCageList();
    },
    submit_drawerStatus() {
      this.cageDetailState = false;
      this.getCageList();
    },

    handleNodeClick(data) {
      this.cageAreaId = "";
      this.positionId = "";
      if (data.children) {
        this.cageAreaId = data.id;
        this.getCageList();
      } else {
        this.positionId = data.id;
        this.getCageList();
      }
    },
    // 获取状态列表
    getStatusList() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/status/list")
        .then((res) => {
          if (res.code == 0) {
            this.statusList = res.data;
            this.statusList.unshift({
              name: "全部",
              id: "",
            });
          }
        });
    },
    
    // 获取笼子位置树
    getCageTree() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/tree", {
          shopId: this.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            // console.log(res.data, "树");
            this.cageData = res.data;
            let arr = [];
            let arrName = [];
            this.cageData.forEach((item) => {
              if (item.children.length) {
                item.children.forEach((itemB) => {
                  arr.push(itemB.id);
                  arrName.push(item.label + "--" + itemB.label);
                });
              }
            });
            this.cagePositionList = arr;
            this.cagePositionNameList = arrName;
          }
        });
    },
    // 查看笼子详情
    cageDetail(item) {
      console.log(item,"itemlongzi");
      this.cageDetailState = true;
      this.cageId = item.cageId;
      this.cageInfo = item;
    },

    changeType(id) {
      this.typeClass = id;
    },
    // 添加笼子
    addShopCage() {
      if (this.areaId == "") {
        this.$message({
          message: "请选择区域",
          type: "error",
        });
        return;
      }
      if (this.positionId == "") {
        this.$message({
          message: "请选择位置",
          type: "error",
        });
        return;
      }
      let params = {
        shopId: this.shopId,
        positionId: this.positionId,
        areaId: this.areaId,
        name: this.name,
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url_8000 + "/api/add/shop/cage", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.positionId = "";
            this.areaId = "";
            this.name = "";
            this.getCageList();
            this.dialogVisible = false;
          }
        });
    },
    // 区域改变
    changeArea() {
      if (this.positionId) {
        this.positionId = "";
      }
      let obj = null;
      this.cageData.forEach((item) => {
        if (item.id == this.areaId) {
          obj = item;
        }
      });
      this.positionList = obj.children;
    },
    // 获取门店笼子区域位置
    getCageArea() {
      this.$http
        .get(process.env.VUE_APP_Url_8000 + "/api/cage/area/list")
        .then((res) => {
          if (res.code == 0) {
            this.areaList = res.data;
            this.$store.commit("set_areaList", this.areaList);
          }
        });
    },
    // 切换门店
    changeCurShopId(e) {
      
      this.shopId = e;
      console.log(this.shopId,"eee");
      this.areaClass = 0;
      this.placeClass = "";
      this.typeClass = "";
      this.getCageTree();
      this.getCageList();
      this.getStatistics();
      this.getStatusList();
    },

    handleClose(done) {
      done();
    },
    //新建房间
    addCage() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  display: flex;
  .cage_state {
    width: 45px;
    height: 20px;
    line-height: 20px;
    font-size: 10px;
    border-radius: 12px;
    text-align: center;
    background: #fff;
  }
  .textClass_1 {
    color: #2f97fe;
  }
  .textClass_2 {
    color: #f9a004;
  }
  .textClass_3 {
    color: #9C9C9D;
  }
  .textClass_4 {
    color: #f54a2a;
  }
  .color_1 {
    background: #2f97fe;
  }

  .color_2 {
    background: #f9a004;
  }

  .color_3 {
    background:#9C9C9D ;
  }

  .color_4 {
    background: #f54a2a;
  }
  .color_5 {
    background: #2ac100;
  }
  .typeView {
    display: flex;
    flex-wrap: wrap;

    div {
      width: 100px;
      margin-right: 10px;
      height: 30px;
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #ccc;

      &.active {
        border: 1px solid $mainColor;
      }
    }
  }

  .leftContent {
    width: 10%;
    height: 100vh;
    position: fixed;
    padding-top: 30px;
    margin-right: 10px;
    background-color: #fff;
    border-radius: 4px;

    .boxItem {
      margin-left: 15px;
      margin-bottom: 20px;

      .itemTitle {
        font-weight: 600;
        margin-bottom: 20px;
      }
    }
  }

  .rightContent {
    width: 90%;
    margin-left: 12%;
    border-radius: 4px;
    background-color: #fff;
    padding: 0px 20px 20px 20px;
    display: flex;
    flex-direction: column;

    .right_top_content {
      width: 78%;
      position: fixed;
      background: #fff;
    }

    .firstContent {
      display: flex;
      margin: 20px 0px;

      .conItem {
        cursor: pointer;
        font-size: 14px;
        margin-right: 30px;
        display: flex;
        height: 20px;
        line-height: 20px;

        .colorView {
          margin-right: 10px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
        }
      }
    }

    .cageView::-webkit-scrollbar {
      display: none;
    }

    .cageView {
      margin: 10% 0px;
      background: #fff;

      .cageName {
        margin-bottom: 10px;
        font-size: 20px;
        padding: 10px;
        font-weight: 600;
      }

      .cageBox {
        display: flex;
        flex-wrap: wrap;

        .cageItem {
          width: 124px;
          height: 95px;
          padding: 10px;
          margin-right: 5px;
          margin-bottom: 10px;
          border-radius: 10px;
          font-size: 14px;
        }
      }
    }
  }

  .dialogItem {
    display: flex;
    margin-bottom: 20px;

    div:nth-child(1) {
      line-height: 40px;
      margin-right: 20px;
    }
  }

  .sx {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .comWrap {
      padding: 20px;
      font-size: 12px;
      color: #666;
      line-height: 20px;

      .comView {
        display: flex;
        margin-bottom: 16px;

        .comName {
          width: 52px;
          text-align: right;
        }

        .comTab {
          flex: 1;
          display: flex;
          flex-wrap: wrap;

          div {
            padding: 0 12px;
            border-right: 1px solid #f2f2f2;
            margin-bottom: 12px;
          }

          div:nth-of-type(1) {
            padding-left: 4px;
          }
        }
      }
    }

    .sxBtn {
      height: 40px;
      display: flex;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;

      div:nth-of-type(1) {
        flex: 1;
        background: #e1e9fb;
        color: #467eff;
      }

      div:nth-of-type(2) {
        flex: 1;
        background: #f5882a;
      }
    }
  }
}
</style>
